export interface FirebaseEnvConfig {
  apiKey: string
  authDomain: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
  measurementId: string
  recaptchaSiteKey: string
}

export interface AppEnvConfig {
  firebase: FirebaseEnvConfig
  stripeKeyTest: string
  stripeKeyLive: string
  appCheckDebugToken: string
}

function getEnvPrefix(): string {
  return __MALU_ACTIVE_ENVIRONMENT__.trim().toUpperCase()
}

function getEnvVar(suffix: string): string {
  return __MALU_VITE_ENV__[`VITE_${getEnvPrefix()}_${suffix}`] ?? ''
}

function resolveStripeKeys(): Pick<AppEnvConfig, 'stripeKeyTest' | 'stripeKeyLive'> {
  return {
    stripeKeyTest: getEnvVar('STRIPE_KEY_TEST'),
    stripeKeyLive: getEnvVar('STRIPE_KEY_LIVE'),
  }
}

export function getActiveEnvConfig(): AppEnvConfig {
  return {
    firebase: {
      apiKey: getEnvVar('FIREBASE_API_KEY'),
      authDomain: getEnvVar('FIREBASE_AUTH_DOMAIN'),
      projectId: getEnvVar('FIREBASE_PROJECT_ID'),
      storageBucket: getEnvVar('FIREBASE_STORAGE_BUCKET'),
      messagingSenderId: getEnvVar('FIREBASE_MESSAGING_SENDER_ID'),
      appId: getEnvVar('FIREBASE_APP_ID'),
      measurementId: getEnvVar('FIREBASE_MEASUREMENT_ID'),
      recaptchaSiteKey: getEnvVar('RECAPTCHA_ENTERPRISE_SITE_KEY'),
    },
    ...resolveStripeKeys(),
    appCheckDebugToken: getEnvVar('FIREBASE_APPCHECK_DEBUG_TOKEN'),
  }
}

export function getStripePublishableKeyForMode(mode: 'test' | 'live'): string {
  const { stripeKeyTest, stripeKeyLive } = getActiveEnvConfig()
  return mode === 'live' ? stripeKeyLive : stripeKeyTest
}
